const hashSign = '#!';
const isExactUrl = (currentUrl, targetUrl) => currentUrl.includes(targetUrl);
const getUrl = (url) => url.substring(0, url.indexOf(hashSign));
const getHashSegments = (url) =>
    url
        .split('#!')
        .slice(-1)[0]
        .split('&');

export const isAlertUrl = (currentUrl, targetUrl) => {
    const hash = currentUrl.substring(currentUrl.indexOf(hashSign));

    if (isExactUrl(currentUrl, targetUrl)) {
        return true;
    }

    if (getUrl(currentUrl) !== getUrl(targetUrl)) {
        return false;
    }

    if (hash && !targetUrl.includes(hashSign)) {
        return false;
    }

    const urlHashSegments = getHashSegments(targetUrl);
    const windowHashSegments = getHashSegments(hash);

    const remainedSegments = urlHashSegments.filter(
        (hashSegment) => !windowHashSegments.indexOf(hashSegment),
    );

    return remainedSegments.length === 0;
};
